// extracted by mini-css-extract-plugin
export var side_image = "index-module--side_image--30973";